<template>
    <div class="search-box" :style="{background: `linear-gradient(90deg,${configData.bgColor.color[0].item} 0%,${configData.bgColor.color[1].item} 100%)`,marginTop:`${configData.mbConfig.val}px`,paddingLeft:`${configData.prConfig.val}px` }" v-if="configData.bgColor.color.length>0">
        <img :src="configData.logoConfig.url" alt="" v-if="configData.logoConfig.url">
        <div class="box" :class="{on: configData.boxStyle.type, center: configData.txtStyle.type == 1}">搜索商品</div>
    </div>
</template>

<script>
    export default {
        name: "search_box",
        sort: 1500,
        cname: '搜索框',
        type: 0, // 0 基础组件 1 营销组件 2工具组件
        icon: 'iconsousukuang1',
        props: {
            configData: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                defaultConfig: {
                    name: "search_box",
                    cname: '搜索',
                    tabs: [
                        {
                            title: '内容设置'
                        },
                        {
                            title: '样式设置'
                        }
                    ],

                    styles: {
                        bgColor: {
                            title: '背景颜色(渐变)',
                            tab: 1,
                            name: 'colors',
                            default: [
                                {
                                    item: '#4985FD'
                                },
                                {
                                    item: '#4985FD'
                                }
                            ],
                            color: [
                                {
                                    item: '#4985FD'
                                },
                                {
                                    item: '#4985FD'
                                }
                            ]
                        },
                        boxStyle: {
                            title: '边框样式',
                            tab: 1,
                            name: 'radio',
                            type: 0,
                            list: [
                                {
                                    val: '圆角',
                                    icon:'iconPic_fillet'
                                },
                                {
                                    val: '直角',
                                    icon:'iconPic_square'
                                }
                            ]
                        },
                        txtStyle: {
                            title: '文本位置',
                            tab: 1,
                            name: 'radio',
                            type: 0,
                            list: [
                                {
                                    val: '居左',
                                    icon:'icondoc_left'
                                },
                                {
                                    val: '居中',
                                    icon:'icondoc_center'
                                }
                            ]
                        },
                        prConfig: {
                            title: '背景边距',
                            tab: 1,
                            name: 'slider',
                            val: 10,
                            min: 0
                        },
                        // 页面间距
                        mbConfig: {
                            title: '页面间距',
                            tab: 1,
                            name: 'slider',
                            val: 0,
                            min: 0
                        },
                        logoConfig:{
                            header: '设置logo',
                            title: '',
                            tab: 0,
                            name: 'editorimage',
                            type: 1,
                            url: ''
                        },
                    }
                }
            }
        },
        mounted () {

        },
    }
</script>

<style scoped lang="less">
    .search-box {
        display: flex;
        align-items: center;
        width: 100%;
        height: 48px;
        padding: 10px 10px 10px 0;
        cursor: pointer;
        box-sizing: border-box;
        img {
            width: 76px;
            height: 30px;
            margin-right: 10px;
        }
        .box {
            flex: 1;
            height: 30px;
            line-height: 30px;
            color: #999;
            font-size:12px;
            padding-left: 10px;
            background: #fff;
            border-radius: 15px;
            &.on {
                border-radius: 0;
            }
            &.center {
                text-align: center;
                padding-left: 0;
            }
        }
    }
</style>
